module.exports = __webpack_public_path__ + "img/cary-migration.a8497e62.png";